import axios from 'axios';
import { getAuthToken } from '../utils/sessionAuth.js';

const API_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/users`;

const authHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const createConsoleUser = async ({ name, email, password, userType }) => {
  const { data } = await axios.post(
    `${API_URL}/createNewUser`,
    { name, email, password, userType },
    { headers: { ...authHeaders(), 'Content-Type': 'application/json' } }
  );
  return data;
};

const updateConsoleUser = async (id, payload) => {
  const { data } = await axios.patch(
    `${API_URL}/${encodeURIComponent(id)}`,
    payload,
    { headers: { ...authHeaders(), 'Content-Type': 'application/json' } }
  );
  return data;
};

const consoleUserService = {
  createConsoleUser,
  updateConsoleUser,
};
export default consoleUserService;
